import { WindowsBanner } from 'common/types/entities/api/template'
import { StateKey } from 'common/utils/flipState'
import { fetchWindowBanners } from 'common/services/template'
import { TemplateManagerKey } from 'common/constants/templateManager'
import { ArrayUtils } from '@shopping/common'

export interface WindowsBannerType {
  artHomeBanners: WindowsBanner[]
  artArtistBanners: WindowsBanner[]
  weeklyArtistBanners: WindowsBanner[]
  eventBandBanner: WindowsBanner
  homeBanners: WindowsBanner[]
}

export const initialBanner: WindowsBannerType = {
  artHomeBanners: null,
  artArtistBanners: null,
  weeklyArtistBanners: null,
  eventBandBanner: null,
  homeBanners: null,
}

const FETCH_ART_HOME_BANNER = 'home/art/FETCH_HOME_BANNER'
const FETCH_ART_BRAND_BANNER = 'home/art/FETCH_ART_BRAND_BANNER'
const FETCH_ART_WEEKLY_BANNER = 'home/art/FETCH_ART_WEEKLY_BANNER'
const FETCH_HOME_MEAL_EVENT_BANNER = 'home/homemeal/FETCH_HOME_MEAL_EVENT_BANNER'
const FETCH_HOME_BANNER = 'home/FETCH_HOME_BANNER'

export const fetchArtHomeBanner = (curState: StateKey) => async dispatch => {
  const homeBanners = await fetchWindowBanners(TemplateManagerKey.ART_HOME_BANNER)
  dispatch({
    curState,
    homeBanners: homeBanners && ArrayUtils.shuffle(homeBanners),
    type: FETCH_ART_HOME_BANNER,
  })
}

export const fetchArtBrandBanner = (curState: StateKey) => async dispatch => {
  const brandBanners = await fetchWindowBanners(TemplateManagerKey.ART_BRAND_HOME_BANNER)
  dispatch({
    curState,
    brandBanners: brandBanners && ArrayUtils.shuffle(brandBanners),
    type: FETCH_ART_BRAND_BANNER,
  })
}

export const fetchArtWeeklyBanner = (curState: StateKey) => async dispatch => {
  const weeklyBanners = await fetchWindowBanners(TemplateManagerKey.ART_HOME_WEEKLY_BANNER)
  const filteredBanners =
    weeklyBanners && weeklyBanners.filter(banner => banner.windowProducts && banner.windowProducts.length > 2)
  dispatch({
    curState,
    weeklyBanners: filteredBanners && ArrayUtils.shuffle(filteredBanners).slice(0, 3),
    type: FETCH_ART_WEEKLY_BANNER,
  })
}

export const fetchEventBandBanner = (curState: StateKey) => async dispatch => {
  const eventBandBanners = await fetchWindowBanners(TemplateManagerKey.HOME_MEAL_EVENT_BANNER)
  dispatch({
    curState,
    eventBandBanner: eventBandBanners && ArrayUtils.shuffle(eventBandBanners)[0],
    type: FETCH_HOME_MEAL_EVENT_BANNER,
  })
}

export const fetchHomeBanner = (curState: StateKey, bannerKey: TemplateManagerKey) => async dispatch => {
  const homeBanners = await fetchWindowBanners(bannerKey)
  dispatch({
    curState,
    homeBanners: homeBanners && ArrayUtils.shuffle(homeBanners),
    type: FETCH_HOME_BANNER,
  })
}

const windowsBannerReducer = (state = initialBanner, action) => {
  switch (action.type) {
    case FETCH_ART_HOME_BANNER:
      return {
        ...state,
        artHomeBanners: action.homeBanners,
      }
    case FETCH_ART_BRAND_BANNER:
      return {
        ...state,
        artArtistBanners: action.brandBanners,
      }
    case FETCH_ART_WEEKLY_BANNER:
      return {
        ...state,
        weeklyArtistBanners: action.weeklyBanners,
      }
    case FETCH_HOME_MEAL_EVENT_BANNER:
      return {
        ...state,
        eventBandBanner: action.eventBandBanner,
      }
    case FETCH_HOME_BANNER:
      return {
        ...state,
        ...action,
      }
    default:
      return state
  }
}

export default windowsBannerReducer
